import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var cookiesAcceptRejectRes;
export const cookiesAcceptRejectTodo = createAsyncThunk('cookiesAcceptReject', async (data) => {
    // console.log("data", data)
    try {
        const res = await axios({
            method: "post",
            url: process.env.REACT_APP_API_URL + 'cookie_log',
            data: {
                "status": data.status,
                "preferences": {
                    "Strictly": data.preferences?.Strictly ?? true,
                    "Analytics": data.preferences?.Analytics ?? false,
                    "Advertising": data.preferences?.Advertising ?? false
                }
            },
            headers: { "Content-Type": "application/json" }
        })
        return cookiesAcceptRejectRes = res

    } catch (error) {
        return cookiesAcceptRejectRes = error.response
    }
})